
import { Component, Emit, Prop, Vue, Model, Watch } from 'vue-property-decorator'
import { dataSource_My } from '@xt/client'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class FormMultipleSelect extends Vue {
  @Prop({ default: () => [], required: true }) options: Array<{
    label: string
    value: number | string
  }>
  @Prop({ default: 'value' }) specifyValue: string

  @Model('change', { type: [String] }) readonly value!: string

  selectValue: string[] = []

  get echoLabel() {
    if (!this.selectValue || this.selectValue.length === 0) return ''

    return this.selectValue.join('、')
  }

  renderPlaceholder() {
    return this.echoLabel
  }

  @Watch('echoLabel')
  onEchoLabelChange() {
    this.$emit('change', this.echoLabel)
  }

  created() {
    if (!this.value) return

    this.selectValue = this.value.split('、').filter(item => dataSource_My.specialtyOptions.some(i => i.value === item))
  }

  mounted() {}

  updated() {}

  destroyed() {}
}
